/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import getColor from "@insite/mobius/utilities/getColor";
import { xBaseTheme } from "@stoneage/XDL/types";
import { styledScrollbar } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

export default {
    css: css`
        *:focus {
            outline: none !important;
        }

        ul {
            margin: 0;
            padding: 0;
            list-style: inherit;
        }

        body {
            ${styledScrollbar(8, "common.ui7")};
            overflow-x: hidden;

            ._ls_sideBar {
                display: none;
            }
            
            @media print {
                font-size: 13px !important;
            }
        }
    `,
} as xBaseTheme["globalStyle"];
